import React, { useEffect, useState } from "react";
import Header from "./Header";
import SideBar from "./Sidebar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem("lis-theme") === "dark" ? "dark" : "light";
    } catch {
      return "light";
    }
  });

  const toggleSidebar = () => {
    setIsSidebarExpanded((prev) => !prev);
  };

  useEffect(() => {
    if (isSidebarExpanded) {
      document.body.classList.add("sidebarMobileExpand");
    } else {
      document.body.classList.remove("sidebarMobileExpand");
    }
  }, [isSidebarExpanded]);

  useEffect(() => {
    document.body.dataset.theme = theme;
    document.documentElement.dataset.bsTheme = theme;
    try {
      localStorage.setItem("lis-theme", theme);
    } catch {
      // Keep the selected theme for this session if storage is unavailable.
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((currentTheme) => (currentTheme === "dark" ? "light" : "dark"));
  };

  return (
    <>
      <Header
        isSidebarExpanded={isSidebarExpanded}
        theme={theme}
        toggleTheme={toggleTheme}
        // setIsSidebarExpanded={setIsSidebarExpanded} 
        toggleSidebar={toggleSidebar}
      />
      <SideBar
        isSidebarExpanded={isSidebarExpanded}
        // setIsSidebarExpanded={setIsSidebarExpanded}
        toggleSidebar={toggleSidebar}
      />
      <div className={`${!isSidebarExpanded ? "pageWrapper" : "pageWrapperClose"}`} >
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default MainLayout;
